import React from "react";

const VanRentalFleet = ({ title, description, stats }) => {
  return (
    <section className="vr-fleet-section">
      <div className="container">
        <div
          className="text-center mb-5"
          data-aos="fade-up"
          data-aos-once="true"
        >
          <h2>{title}</h2>
          {description && <p>{description}</p>}
        </div>

        <div className="row g-4 justify-content-center">
          {stats.map((stat, i) => (
            <div
              key={i}
              className="col-6 col-md-4 col-lg-2"
              data-aos="fade-up"
              data-aos-delay={`${(i % 6) * 80}`}
              data-aos-duration="700"
              data-aos-once="true"
            >
              <div className="vr-fleet-stat">
                <span className="vr-fleet-value">{stat.value}</span>
                <span className="vr-fleet-label">{stat.label}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VanRentalFleet;
